import React, { useContext, useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import cn from 'classnames';
import { FlowContext } from '../../core/flow-engine';
import styles from './style.css';
import TimeOutModal from '../TimeOutModal/TimeOutModal';
import StickyCallNowBanner from '../StickyCallNowBanner/StickyCallNowBanner';
import { isFrontOffice } from '../../config';

/* eslint-disable complexity */
const BaseLayout = ({ children }) => {
  const { appState, flowProps } = useContext(FlowContext);
  const {
    header: Header,
    footer: Footer,
    layoutClass,
    displayStickyBanner
  } = flowProps;
  const [cookies] = useCookies(['mobile']);
  const [isMobileView, setMobileView] = useState(false);

  useEffect(() => {
    // US524596 - if "mobile=1" url query param or cookie is present
    // hide header/footer components for mobile iframe
    const queryParams = new URLSearchParams(window.location.search);
    const mobileQuery = queryParams.get('mobile');

    /* double equality due to unknown variable type for cookie; matches number or string value of 1 */
    // eslint-disable-next-line eqeqeq
    if (mobileQuery === '1' || cookies?.mobile == '1') {
      setMobileView(true);
    }
  }, []);

  const {
    store: { authenticated }
  } = appState;

  return (
    <div className={cn('base-layout-wrapper', layoutClass)}>
      {authenticated && <TimeOutModal />}
      {isMobileView || isFrontOffice() || <Header />}
      {/* element for screen readers to read out form validation errors - US537163 */}
      <p
        id="readFormErrors"
        role="alert"
        aria-atomic="true"
        className="visually-hidden"
      />
      <div className="site-content">{children}</div>
      {displayStickyBanner && <StickyCallNowBanner />}
      {isMobileView || isFrontOffice() || <Footer />}
      <style jsx>{styles}</style>
    </div>
  );
};

export default BaseLayout;
